var $0e518af4f08c31a6$exports = {};
$0e518af4f08c31a6$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$0e518af4f08c31a6$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
